// rh-footer/rh-footer.js
import { createComponent } from '@lit/react';
import react from 'react';
import { RhFooter } from '@rhds/elements/rh-footer/rh-footer.js';
export const Footer = createComponent({
  tagName: 'rh-footer',
  elementClass: RhFooter,
  react,
  events: {},
});
